import React from 'react';
import { StickyTopBar } from './components/StickyTopBar';
import { HeroSection } from './components/HeroSection';
import { SocialProof } from './components/SocialProof';
import { ProblemSection } from './components/ProblemSection';
import { TransitionSection } from './components/TransitionSection';
import { ProductPresentation } from './components/ProductPresentation';
import { ModulesSection } from './components/ModulesSection';
import { BonusSection } from './components/BonusSection';
import { UrgencySection } from './components/UrgencySection';
import { OfferSection } from './components/OfferSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { PurchasePopup } from './components/PurchasePopup';
import { useMetaPixel } from './hooks/useMetaPixel';
const CHECKOUT_URL = 'https://elrincondigital.click/checkouts/cn/hWNAzaPwalqJbEBkJzoRb77i/es-ar?_r=AQABbAjs0DzDdFIIbrt4qklW5wXh1DsjTniDg14oVlNZ2AE&preview_theme_id=154785841310';
export function App() {
  const {
    trackCheckout
  } = useMetaPixel();
  const handleScrollToOffer = () => {
    const offerSection = document.getElementById('oferta');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const handleCheckout = () => {
    trackCheckout();
    window.location.href = CHECKOUT_URL;
  };
  return <div className="min-h-screen bg-[#0B1D3A] font-['Inter',sans-serif] selection:bg-[#00B4D8] selection:text-white" data-id="element-0">
      <StickyTopBar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection onScrollToOffer={handleScrollToOffer} data-id="element-3" />
        <SocialProof data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <TransitionSection data-id="element-6" />
        <ProductPresentation onScrollToOffer={handleScrollToOffer} data-id="element-7" />
        <ModulesSection data-id="element-8" />
        <BonusSection onScrollToOffer={handleScrollToOffer} data-id="element-9" />
        <UrgencySection data-id="element-10" />
        <OfferSection onCheckout={handleCheckout} data-id="element-11" />
        <TestimonialsSection data-id="element-12" />
        <GuaranteeSection data-id="element-13" />
        <FAQSection onCheckout={handleCheckout} data-id="element-14" />
      </main>

      <PurchasePopup data-id="element-15" />
    </div>;
}